
import { defineComponent } from 'vue';
import { PersianDate } from '@/Utils/persian-date';

export default defineComponent({
    name: "LogsSystemTableComponent",

    props: ["logs"],


    data() {
        return {
            persianDateConverter: new PersianDate(),
            moreOptions: {
                show: false,
                userId: ""
            },
            tableHeaders: [
                "عنوان",
                "مشخصات ادمین",
                " مشخصات کاربر",
                "عملیات",
                "تاریخ ایجاد"
            ],
        }
    },

    methods: {
        persianDate(utcDateTime: string): string {
            return this.persianDateConverter.convert(utcDateTime, true);
        },

        FormatPersianAmount(amount: number | string): string {
            // Convert to number if it's a string
            const num = typeof amount === 'string' ? parseFloat(amount) : amount;

            if (isNaN(num)) {
                return "مبلغ نا معتبر"; // Or handle the error as you prefer
            }

            const parts = num.toString().split(".");
            const integerPart = parts[0];
            const fractionalPart = parts[1] || '';

            // Apply thousands separator to the integer part
            const formattedIntegerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

            // Combine integer and fractional parts
            const formattedAmount = fractionalPart ? `${formattedIntegerPart}.${fractionalPart}` : formattedIntegerPart;

            return formattedAmount;
        },

        logType(type: string): string {
            let textType = "";
            switch (type) {
                case 'ADMIN_ACTION':
                    textType = 'ادمین';
                    break;
                case 'USER_ACTION':
                    textType = 'کاربر';
                    break;
            
                default:
                    textType = 'نا مشخص'
                    break;
            }

            return textType;
        }
    },
})
